(() => {
  const navigateWithinPage = event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target === '_blank' || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    let url;
    let destination;
    try {
      url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
      destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch (_) { return; }
    if (!destination) return;
    event.stopPropagation();
    if (event.defaultPrevented) return;
    event.preventDefault();
    const hadTabindex = destination.hasAttribute('tabindex');
    if (!hadTabindex) destination.tabIndex = -1;
    destination.focus({ preventScroll: true });
    if (!hadTabindex) destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), { once: true });
    const header = document.getElementById('shopify-section-header');
    const offset = (header ? header.getBoundingClientRect().height : 0) + 18;
    const top = Math.max(0, window.scrollY + destination.getBoundingClientRect().top - offset);
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    if (location.hash !== url.hash) history.pushState(null, '', `${location.pathname}${location.search}${url.hash}`);
  };
  const boot = () => {
    const container = document.querySelector('.PageContainer');
    if (container && !container.dataset.sikAnchorNavigation) {
      container.dataset.sikAnchorNavigation = 'true';
      container.addEventListener('click', navigateWithinPage);
    }
    document.querySelectorAll('.sik-nav__mobile').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    const success = document.querySelector('.sik-form-success');
    if (success && new URLSearchParams(location.search).has('customer_posted')) { success.focus({preventScroll:true}); success.scrollIntoView({block:'center'}); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
